import {Component} from '@angular/core';
import {UserService} from '../services/user.service';
import {User} from '../model/user.class';
import {Publisher} from '../model/publisher.class';
import {ActivatedRoute, Router} from '@angular/router';
import {Media} from '../model/media.class';

@Component({
    selector: 'app-media-update',
    templateUrl: './media.update.component.html'
})
export class MediaUpdateComponent {

    public media: Media;
    public publishers: Publisher[];
    public message = '';
    public user: User;
    public admin: string;
    public imagePath = '';
    public mediumTypes = ['Buch', 'Spiel', 'Lernmaterial', 'Archiv'];

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.userService.uploader.clearQueue();
        this.route.params.subscribe(
            (params) => {
                userService.get(params['mediaId'], 'media').subscribe(media => {
                    this.media = media as Media;
                    this.imagePath = userService.determineImageUrl(this.media);
                    this.user = userService.user;
                    this.admin = userService.Admin;
                    if (userService.user.userType === userService.Admin) {
                        // Es werden nur Verlage geholt, die nicht zum Administrator gehören,
                        // um zu vermeiden, dass aus Versehen ein Medium dem Admin zugeordnet wird
                        userService.getPublishersWithout(userService.user.publisher.publisherId).subscribe(data => {
                            this.publishers = data;
                            this.publishers.forEach(publisher => {
                                if (publisher.publisherId === this.media.publisher.publisherId) {
                                    this.media.publisher = publisher;
                                }
                            });
                        });
                    }
                });
            });
    }

    updateMedia() {
        this.message = 'Update des Mediums wird durchgeführt. Dies kann je nach Größe des Mediums einige Sekunden bis Minuten dauern...';
        this.media.lasModificationDate = new Date();
        this.userService.update(this.media, 'media').subscribe(
            (data) => {
                const actMedia = data as Media;
                this.userService.uploadCover(actMedia).subscribe(
                    () => this.router.navigate(['/publisher/detail', actMedia.publisher.publisherId]),
                    (err) => this.message = 'Fehler beim Upload des Covers!'
                );
            },
            (err) => {
                this.message = 'Fehler beim Ändern des Mediums: ' + err._body;
            });
    }
}




// WEBPACK FOOTER //
// ./src/app/mediaUpdate/media.update.component.ts